/**
 * Textos de bloqueio por permissão de tela e de recusa de login (situação
 * inativa). Registrados no dicionário principal pelo IdiomaProvider.
 */
export const TEXTOS_ACESSO_PERMISSAO = {
  pt: {
    "Você não tem permissão para acessar esta tela.":
      "Você não tem permissão para acessar esta tela.",
    "Login inativo. Fale com um administrador.": "Login inativo. Fale com um administrador.",
    "Perfil de acesso inativo. Fale com um administrador.":
      "Perfil de acesso inativo. Fale com um administrador.",
    "Sua sessão foi encerrada: o login foi desativado. Fale com um administrador.":
      "Sua sessão foi encerrada: o login foi desativado. Fale com um administrador.",
  },
  en: {
    "Você não tem permissão para acessar esta tela.":
      "You do not have permission to access this screen.",
    "Login inativo. Fale com um administrador.":
      "Inactive login. Contact an administrator.",
    "Perfil de acesso inativo. Fale com um administrador.":
      "Inactive access profile. Contact an administrator.",
    "Sua sessão foi encerrada: o login foi desativado. Fale com um administrador.":
      "Your session was ended: this login has been deactivated. Contact an administrator.",
  },
  es: {
    "Você não tem permissão para acessar esta tela.":
      "No tienes permiso para acceder a esta pantalla.",
    "Login inativo. Fale com um administrador.":
      "Inicio de sesión inactivo. Habla con un administrador.",
    "Perfil de acesso inativo. Fale com um administrador.":
      "Perfil de acceso inactivo. Habla con un administrador.",
    "Sua sessão foi encerrada: o login foi desativado. Fale com um administrador.":
      "Tu sesión fue cerrada: el inicio de sesión fue desactivado. Habla con un administrador.",
  },
  "zh-CN": {
    "Você não tem permissão para acessar esta tela.": "您没有权限访问此页面。",
    "Login inativo. Fale com um administrador.": "登录账号已停用，请联系管理员。",
    "Perfil de acesso inativo. Fale com um administrador.": "访问权限配置已停用，请联系管理员。",
    "Sua sessão foi encerrada: o login foi desativado. Fale com um administrador.":
      "您的会话已结束：该登录账号已被停用，请联系管理员。",
  },
};
